import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import EEArticle from "@ee/components/EEArticle";
import EEFooter from "@ee/components/EEFooterComponents/EEFooter";
import EENominationsDescription from "@ee/components/EENominationsDescription";
import EEOrganiserDetails from "@ee/components/EEOrganiserDetails";
import EERecognitionSection from "@ee/components/EERecognitionSection";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_EE_LABEL,
  EVENTS_AWARDS_EE_PATH,
} from "@events-awards/utils/constants";
import {
  AwardType,
  EventsAwardsHomePageContextData,
} from "@events-awards/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

/**
 * Component to render EE page
 */
const EventsAwardsEEPageContent = ({
  articleProps,
}: EventsAwardsHomePageContextData): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  return (
    <div
      className="w-full"
      data-testid="events-awards-ee-page-content-component"
    >
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={EVENTS_AWARDS_EE_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Emerging Enterprise"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title="Emerging Enterprise Latest News & Headlines - THE BUSINESS TIMES"
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_EE_LABEL} - Find ${EVENTS_AWARDS_EE_LABEL} News & Headlines, insight and analysis in Singapore, Asia-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_EE_PATH}
      />

      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.EE} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <EEArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <EERecognitionSection />

      <div className="mt-1 bg-gray-150 px-3 py-8 md:px-6 lg:px-0">
        <Container>
          <EENominationsDescription />
        </Container>
      </div>

      <EEOrganiserDetails />

      <EEFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsEEPageContent;
